var _classCallCheck = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Bmob = require('./bmob');

var request = require('./request');

var _require = require('./dataType'),
    isObject = _require.isObject,
    isString = _require.isString,
    isNumber = _require.isNumber,
    isUndefined = _require.isUndefined,
    isArray = _require.isArray;

var Error = require('./error');

var storage = require('./storage');

var query =
/*#__PURE__*/
function () {
  "use strict";

  function query(parmas) {
    _classCallCheck(this, query);

    this.tableName = "".concat(Bmob._config.parameters.QUERY, "/").concat(parmas);
    this.className = parmas;
    this.init();
    this.addArray = {};
    this.setData = {};
  }

  _createClass(query, [{
    key: "init",
    value: function init() {
      this.queryData = {};
      this.location = {};
      this.andData = {};
      this.orData = {};
      this.stat = {};
      this.limitNum = 100;
      this.skipNum = 0;
      this.includes = '';
      this.queryReilation = {};
      this.orders = null;
      this.keys = null;
    }
  }, {
    key: "get",
    value: function get(ObjectId) {
      var _this = this;

      if (!isString(ObjectId)) {
        throw new Error(415);
      }

      var oneData = {};
      var incrementData = {};
      var unsetData = {};
      var addArray = {};

      var add = function add(key, val) {
        if (!isString(key) || !isArray(val)) {
          throw new Error(415);
        }

        addArray[key] = {
          __op: 'Add',
          objects: val
        };
      };

      var addUnique = function addUnique(key, val) {
        if (!isString(key) || !isArray(val)) {
          throw new Error(415);
        }

        addArray[key] = {
          __op: 'AddUnique',
          objects: val
        };
      };

      var remove = function remove(key, val) {
        if (!isString(key) || !isArray(val)) {
          throw new Error(415);
        }

        addArray[key] = {
          __op: 'Remove',
          objects: val
        };
      };

      var increment = function increment(key) {
        var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        if (!isString(key) || !isNumber(val)) {
          throw new Error(415);
        }

        incrementData[key] = {
          __op: 'Increment',
          amount: val
        };
      };

      var unset = function unset(key) {
        if (!isString(ObjectId)) {
          throw new Error(415);
        }

        unsetData[key] = {
          __op: 'Delete'
        };
      };

      var set = function set(key, val) {
        if (!isString(key) || isUndefined(val)) {
          throw new Error(415);
        }

        var filename = val.filename,
            cdn = val.cdn,
            url = val.url;

        if (!isUndefined(filename) && !isUndefined(cdn) && !isUndefined(url)) {
          oneData[key] = {
            __type: 'File',
            group: cdn,
            filename: filename,
            url: url
          };
        } else {
          oneData[key] = val;
        }
      };

      var save = function save() {
        var saveData = Object.assign(unsetData, oneData, incrementData, addArray);

        if (_this.className === '_User') {
          return new Promise(function (resolve, reject) {
            request("".concat(_this.tableName, "/").concat(ObjectId), 'put', saveData).then(function (results) {
              var current = _this.current();

              var newStorage = Object.assign(current, saveData);
              storage.save('bmob', newStorage);
              resolve(results);
            }).catch(function (err) {
              reject(err);
            });
          });
        }

        return request("".concat(_this.tableName, "/").concat(ObjectId), 'put', saveData);
      };

      var associated = {};

      if (this.includes !== '') {
        associated.include = this.includes;
      }

      return new Promise(function (resolve, reject) {
        request("".concat(_this.tableName, "/").concat(ObjectId), 'get', associated).then(function (results) {
          Object.defineProperty(results, 'set', {
            value: set
          });
          Object.defineProperty(results, 'unset', {
            value: unset
          });
          Object.defineProperty(results, 'save', {
            value: save
          });
          Object.defineProperty(results, 'increment', {
            value: increment
          });
          Object.defineProperty(results, 'add', {
            value: add
          });
          Object.defineProperty(results, 'remove', {
            value: remove
          });
          Object.defineProperty(results, 'addUnique', {
            value: addUnique
          });
          Object.defineProperty(results, 'destroy', {
            value: function value() {
              return _this.destroy(ObjectId);
            }
          });
          resolve(results);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "destroy",
    value: function destroy(ObjectId) {
      if (!isString(ObjectId)) {
        throw new Error(415);
      }

      return request("".concat(this.tableName, "/").concat(ObjectId), 'delete');
    }
  }, {
    key: "set",
    value: function set(key, val) {
      if (!isString(key) || isUndefined(val)) {
        throw new Error(415, "".concat(key, "\u5B57\u6BB5\u53C2\u6570,\u7C7B\u578B\u4E0D\u6B63\u786E"));
      }

      var filename = val.filename,
          cdn = val.cdn,
          url = val.url;

      if (!isUndefined(filename) && !isUndefined(cdn) && !isUndefined(url)) {
        this.setData[key] = {
          __type: 'File',
          group: cdn,
          filename: filename,
          url: url
        };
      } else {
        this.setData[key] = val;
      }
    }
  }, {
    key: "add",
    value: function add(key, val) {
      if (!isString(key) || !isArray(val)) {
        throw new Error(415);
      }

      this.addArray[key] = {
        __op: 'Add',
        objects: val
      };
    }
  }, {
    key: "addUnique",
    value: function addUnique(key, val) {
      if (!isString(key) || !isArray(val)) {
        throw new Error(415);
      }

      this.addArray[key] = {
        __op: 'AddUnique',
        objects: val
      };
    }
  }, {
    key: "current",
    value: function current() {
      if (Bmob.type !== 'hap') {
        var data = storage.fetch('bmob');
        return typeof data === 'object' ? data : JSON.parse(data);
      } else {
        // 快应用功能
        return new Promise(function (resolve, reject) {
          return storage.fetch('bmob').then(function (res) {
            resolve(res);
          }).catch(function (err) {
            reject(err);
          });
        });
      }
    }
  }, {
    key: "updateStorage",
    value: function updateStorage(id) {
      var _this2 = this;

      if (!isString(id)) {
        throw new Error(415);
      }

      return new Promise(function (resolve, reject) {
        var current = _this2.current();

        if (!current) {
          throw new Error(415);
        }

        _this2.get(id).then(function (res) {
          var newStorage = Object.assign(current, res);
          storage.save('bmob', newStorage);
          resolve(res);
        }).catch(function (err) {
          console.log(err);
          reject(err);
        });
      });
    }
  }, {
    key: "save",
    value: function save() {
      var _this3 = this;

      var parmas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!isObject(parmas)) {
        throw new Error(415);
      }

      var method = this.setData.id ? 'PUT' : 'POST';
      var objectId = this.setData.id ? this.setData.id : '';
      delete this.setData.id;
      var saveData = Object.assign(parmas, this.setData, this.addArray);
      return new Promise(function (resolve, reject) {
        request("".concat(_this3.tableName, "/").concat(objectId), method, saveData).then(function (results) {
          _this3.addArray = {};
          _this3.setData = {};

          if (_this3.className === '_User') {
            var current = _this3.current();

            var newStorage = Object.assign(current, saveData);
            storage.save('bmob', newStorage);
          }

          resolve(results);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "saveAll",
    value: function saveAll(items) {
      var _this4 = this;

      if (!isArray(items)) {
        throw new Error(415);
      }

      if (items.length < 1) {
        throw new Error(416);
      }

      var id;
      var p;
      var m = 'put';
      var key = [];
      items.map(function (item) {
        id = "/".concat(item.objectId);

        if (id === '/undefined') {
          id = '';
          m = 'post';
        }

        p = {
          method: m,
          path: "".concat(_this4.tableName).concat(id),
          body: item.setData
        };
        key.push(p);
        return item;
      });
      var params = {
        requests: key
      };
      var route = Bmob._config.parameters.BATCH; // 批量操作

      return request(route, 'POST', params);
    }
  }, {
    key: "withinKilometers",
    value: function withinKilometers(field, _ref) {
      var latitude = _ref.latitude,
          longitude = _ref.longitude;
      var km = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      var newData = {};
      newData[field] = {
        $nearSphere: {
          __type: 'GeoPoint',
          latitude: latitude,
          longitude: longitude
        },
        $maxDistanceInKilometers: km
      };
      this.location = newData;
      return newData;
    }
  }, {
    key: "withinGeoBox",
    value: function withinGeoBox(field, _ref2, s) {
      var latitude = _ref2.latitude,
          longitude = _ref2.longitude;
      var newData = {};
      newData[field] = {
        $within: {
          $box: [{
            __type: 'GeoPoint',
            latitude: latitude,
            longitude: longitude
          }, {
            __type: 'GeoPoint',
            latitude: s.latitude,
            longitude: s.longitude
          }]
        }
      };
      this.location = newData;
      return newData;
    }
  }, {
    key: "statTo",
    value: function statTo(key, val) {
      if (!isString(key)) {
        throw new Error(415);
      }

      this.stat[key] = val;
      return this.stat;
    }
  }, {
    key: "equalTo",
    value: function equalTo(key, operator, val) {
      if (!isString(key)) {
        throw new Error(415);
      }

      var judge = function judge(key, operator, val) {
        var data = {};
        var value = null;

        if (key === 'createdAt' || key === 'updateAt') {
          value = {
            __type: 'Date',
            iso: val
          };
        } else {
          value = val;
        }

        switch (operator) {
          case '==':
            data[key] = value;
            break;

          case '===':
            data[key] = value;
            break;

          case '!=':
            data[key] = {
              $ne: value
            };
            break;

          case '<':
            data[key] = {
              $lt: value
            };
            break;

          case '<=':
            data[key] = {
              $lte: value
            };
            break;

          case '>':
            data[key] = {
              $gt: value
            };
            break;

          case '>=':
            data[key] = {
              $gte: value
            };
            break;

          default:
            throw new Error(415);
        }

        return data;
      };

      var newData = judge(key, operator, val);

      if (Object.keys(this.queryData).length) {
        if (!isUndefined(this.queryData.$and)) {
          this.queryData.$and.push(newData);
        } else {
          this.queryData = {
            $and: [this.queryData, newData]
          };
        }
      } else {
        this.queryData = newData;
      }

      return newData;
    }
  }, {
    key: "containedIn",
    value: function containedIn(key, val) {
      if (!isString(key) || !isArray(val)) {
        throw new Error(415);
      }

      return queryData.call(this, key, '$in', val);
    }
  }, {
    key: "notContainedIn",
    value: function notContainedIn(key, val) {
      if (!isString(key) || !isArray(val)) {
        throw new Error(415);
      }

      return queryData.call(this, key, '$nin', val);
    }
  }, {
    key: "exists",
    value: function exists(key) {
      if (!isString(key)) {
        throw new Error(415);
      }

      return queryData.call(this, key, '$exists', true);
    }
  }, {
    key: "doesNotExist",
    value: function doesNotExist(key) {
      if (!isString(key)) {
        throw new Error(415);
      }

      return queryData.call(this, key, '$exists', false);
    }
  }, {
    key: "or",
    value: function or() {
      for (var _len = arguments.length, querys = new Array(_len), _key = 0; _key < _len; _key++) {
        querys[_key] = arguments[_key];
      }

      querys.map(function (item, i) {
        if (!isObject(item)) {
          throw new Error(415);
        }
      });
      var queryData = this.queryData.$and;

      if (!isUndefined(queryData)) {
        for (var i = 0; i < queryData.length; i++) {
          for (var k = 0; k < querys.length; k++) {
            if (JSON.stringify(queryData[i]) === JSON.stringify(querys[k])) {
              this.queryData.$and.splice(i, 1);
            }
          }
        }

        if (!queryData.length) {
          delete this.queryData.$and;
        }
      }

      this.orData = {
        $or: querys
      };
    }
  }, {
    key: "and",
    value: function and() {
      for (var _len2 = arguments.length, querys = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        querys[_key2] = arguments[_key2];
      }

      querys.map(function (item, i) {
        if (!isObject(item)) {
          throw new Error(415);
        }
      });
      this.andData = {
        $and: querys
      };
    }
  }, {
    key: "limit",
    value: function limit(parmas) {
      if (!isNumber(parmas)) {
        throw new Error(415);
      }

      if (parmas > 1000) {
        parmas = 1000;
      }

      this.limitNum = parmas;
    }
  }, {
    key: "skip",
    value: function skip(parmas) {
      if (!isNumber(parmas)) {
        throw new Error(415);
      }

      this.skipNum = parmas;
    }
  }, {
    key: "order",
    value: function order() {
      for (var _len3 = arguments.length, key = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        key[_key3] = arguments[_key3];
      }

      key.map(function (item) {
        if (!isString(item)) {
          throw new Error(415);
        }
      });
      this.orders = key.join(',');
    }
  }, {
    key: "include",
    value: function include() {
      for (var _len4 = arguments.length, key = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        key[_key4] = arguments[_key4];
      }

      key.map(function (item) {
        if (!isString(item)) {
          throw new Error(415);
        }
      });
      this.includes = key.join(',');
    }
  }, {
    key: "select",
    value: function select() {
      for (var _len5 = arguments.length, key = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        key[_key5] = arguments[_key5];
      }

      key.map(function (item) {
        if (!isString(item)) {
          throw new Error(415);
        }
      });
      this.keys = key.join(',');
    }
  }, {
    key: "field",
    value: function field(key, objectId) {
      if (!isString(key) || !isString(objectId)) {
        throw new Error(415);
      }

      this.queryReilation.where = {
        $relatedTo: {
          object: {
            __type: 'Pointer',
            className: this.className,
            objectId: objectId
          },
          key: key
        }
      };
    }
  }, {
    key: "relation",
    value: function relation(tableName) {
      if (!isString(tableName)) {
        throw new Error(415);
      }

      if (tableName === '_User') {
        tableName = 'users';
      } else {
        tableName = "classes/".concat(tableName);
      }

      this.queryReilation.count = 1;
      var parmas = Object.assign(this.getParams(), this.queryReilation);
      return new Promise(function (resolve, reject) {
        request("/1/".concat(tableName), 'get', parmas).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getParams",
    value: function getParams() {
      var parmas = {};

      if (Object.keys(this.queryData).length) {
        parmas.where = this.queryData;
      }

      if (Object.keys(this.location).length) {
        parmas.where = Object.assign(this.location, this.queryData);
      }

      if (Object.keys(this.andData).length) {
        parmas.where = Object.assign(this.andData, this.queryData);
      }

      if (Object.keys(this.orData).length) {
        parmas.where = Object.assign(this.orData, this.queryData);
      }

      parmas.limit = this.limitNum;
      parmas.skip = this.skipNum;
      parmas.include = this.includes;
      parmas.order = this.orders;
      parmas.keys = this.keys;

      if (Object.keys(this.stat).length) {
        parmas = Object.assign(parmas, this.stat);
      }

      for (var key in parmas) {
        if (parmas.hasOwnProperty(key) && parmas[key] === null || parmas[key] === 0 || parmas[key] === '') {
          delete parmas[key];
        }
      }

      return parmas;
    }
  }, {
    key: "find",
    value: function find() {
      var _this5 = this;

      var oneData = {};
      var items = {};
      var parmas = this.getParams();

      var set = function set(key, val) {
        if (!key || isUndefined(val)) {
          throw new Error(415);
        }

        oneData[key] = val;
      };

      var batch = function batch() {
        var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'updata';
        console.log(method);

        if (items.length < 1) {
          throw new Error(416);
        }

        var id;
        var p;
        var m = 'put';
        var key = [];
        items.map(function (item) {
          id = "/".concat(item.objectId);

          if (id === '/undefined') {
            id = '';
            m = 'post';
          }

          p = {
            method: m,
            path: "".concat(_this5.tableName).concat(id),
            body: oneData
          };

          if (method === 'delete') {
            p = {
              method: 'DELETE',
              path: "".concat(_this5.tableName).concat(id)
            };
          }

          key.push(p);
          return item;
        });
        var params = {
          requests: key
        }; // 批量操作

        var route = Bmob._config.parameters.BATCH;
        return request(route, 'POST', params);
      };

      return new Promise(function (resolve, reject) {
        request("".concat(_this5.tableName), 'get', parmas).then(function (res) {
          var results = res.results;

          if (parmas.hasOwnProperty('count')) {
            results = res;
          }

          _this5.init();

          Object.defineProperty(results, 'set', {
            value: set
          });
          Object.defineProperty(results, 'saveAll', {
            value: function value() {
              return batch();
            }
          });
          Object.defineProperty(results, 'destroyAll', {
            value: function value() {
              return batch('delete');
            }
          });
          items = results;
          resolve(results);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "count",
    value: function count() {
      var _this6 = this;

      var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var parmas = {};

      if (Object.keys(this.queryData).length) {
        parmas.where = this.queryData;
      }

      if (Object.keys(this.andData).length) {
        parmas.where = Object.assign(this.andData, this.queryData);
      }

      if (Object.keys(this.orData).length) {
        parmas.where = Object.assign(this.orData, this.queryData);
      }

      parmas.count = 1;
      parmas.limit = limit;
      return new Promise(function (resolve, reject) {
        request("".concat(_this6.tableName), 'get', parmas).then(function (_ref3) {
          var count = _ref3.count;
          resolve(count);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }]);

  return query;
}();

function queryData(key, operator, val) {
  var parent = {};
  var child = {};
  child[operator] = val;
  parent[key] = child;
  var newData = parent;

  if (Object.keys(this.queryData).length) {
    if (!isUndefined(this.queryData.$and)) {
      this.queryData.$and.push(newData);
    } else {
      this.queryData = {
        $and: [this.queryData, newData]
      };
    }
  } else {
    this.queryData = newData;
  }

  return newData;
}

module.exports = query;